export const GB_FEATURES = {
  EXP_PUPPY_PAGE: 'exp_puppy_page'
};
